import React from 'react';
import PropTypes from 'prop-types';

import messages from './messages';
import WebsiteComponent from './components/websiteComponent';

const FinancialAidInfoWebsite = ({ onChange, initialValue, formatMessage }) => (
  <WebsiteComponent
    name="Transfer-Financial-Aid-Info"
    value={initialValue.value}
    onChange={onChange}
    stylesName="transfer-website-container"
    placeholder={formatMessage(messages.transferFinancialAidInfoWebsite)}
    showError={initialValue.showError}
  />
);

FinancialAidInfoWebsite.propTypes = {
  onChange: PropTypes.func,
  formatMessage: PropTypes.func,
  initialValue: PropTypes.object,
};

export default FinancialAidInfoWebsite;
